<template>
  <div class="page-header">
    <div class="pull-left text-xl">
      <span class="pull-left">Параметры этажа</span>
    </div>
  </div>


  <CustomTabs
    :data="tabs"
    :tab="tab"
    @change_tab="onTabChange"
  />

  <FloorParamTypes v-if="tab === 'floorParamTypes'" />
  <FloorPlanTypes v-if="tab === 'floorPlanTypes'" />
  <ProjectLink v-if="tab === 'projectLink'" />
  <ParamLink v-if="tab === 'paramLink'" />
  <ParamValueLink v-if="tab === 'paramValueLink'" />
</template>

<script>
import CustomTabs from "@/components/common/CustomTabs";
import FloorParamTypes from "./FloorParamTypes";
import ProjectLink from "./ProjectLink";
import ParamLink from "./ParamLink";
import FloorPlanTypes from "./FloorPlanTypes";
import ParamValueLink from "./ParamValueLink";

export default {
  name: "FloorParams",
  components: {
    CustomTabs,
    FloorParamTypes,
    ProjectLink,
    ParamLink,
    FloorPlanTypes,
    ParamValueLink,
  },
  data() {
    return {
      tab: this.$route.query.tab || "floorParamTypes",
      tabs: [
        { name: "floorParamTypes", label: "Параметры этажа" },
        { name: "floorPlanTypes", label: "Параметры планировки" },
        // { name: "projectLink", label: "Привязка к типу проекта" },
        { name: "paramLink", label: "Привязка к параметрам" },
        { name: "paramValueLink", label: "Связка параметров" },
      ],
    };
  },
  watch: {
    "$route.query.tab": {
      immediate: true,
      handler(newTab) {
        if (newTab) {
          this.tab = newTab;
        }
      },
    },
  },
  methods: {
    onTabChange(newTab) {
      this.tab = newTab;
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: newTab,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.page-header {
  margin-bottom: 15px;
  .pull-left {
    display: inline-block;
    vertical-align: middle;
    font-size: 32px;
  }
}

.alert {
  margin-bottom: 15px;
}
</style>